import React, { useEffect, useState } from 'react'
import Footer from '../components/Shared/Footer'
import Header from '../components/Shared/Header'
import Navigation from '../components/Shared/Navigation'
import Modals from '../components/Shared/Modals'
import WelcomeModal from '../components/Shared/WelcomeModal'
import * as amplitude from '@amplitude/analytics-browser'
import { ExperimentProvider } from '../context/ExperimentContext';
import { initializeAmplitudeSessionReplay, AMPLITUDE_API_KEY } from './initializeAmplitudeSessionReplay'
// import { startIntercomPolling } from '../utils/helpers';
import 'swiper/swiper.min.css'
import '../styles/layout.css'

const isProd = process.env.NODE_ENV === 'production'

const Layout = ({
  children,
  headerClasses,
  customHero,
  heroBodyStyle,
  heroBodyClasses,
  heroContainerId = 'maximusHeroID',
  data = null,
  lightMode = false,
  headerDisable = false,
  footerDisable = false,
  signUpUrl = null,
  signUpText = null,
  signInHide = false,
  navStatic = false
}) => {
  const [topAdBannerOffset, setTopAdBannerOffset] = useState(0)
  const isClientSide = typeof window !== 'undefined'

  const checkTopAdBannerOffset = () => {
    const topBar = document.querySelector('.top-bar')
    if (topBar) {
      setTopAdBannerOffset(topBar.offsetHeight)
    }
  }

  useEffect(() => {
    checkTopAdBannerOffset()

    if (!isProd) {
      return
    }

    window.analytics.ready(() => {
      initializeAmplitudeSessionReplay()

      amplitude.init(AMPLITUDE_API_KEY, null, {
        autocapture: true,
        deviceId: window.analytics.user().anonymousId(),
      })
      //Disabling until CS is ready to handle the extra volume DPS 2025-01-29
      //startIntercomPolling()
    })
  }, [])

  if (isClientSide) {
    if (window.localStorage && window.location.search) {
      window.localStorage.setItem('searchParams', window.location.search)
    }
  }

  return (
    <ExperimentProvider>
      {!headerDisable && data.settings && data.settings.navigation && (
        <Navigation
          navigation={data.settings.navigation}
          topBar={data.pageSettings.topAdBanner}
          signUpUrl={signUpUrl}
          signUpText={signUpText}
          signInHide={signInHide}
          navStatic={navStatic}
        />
      )}
      {(data.hero || data.contacts || customHero) && !lightMode && (
        <Header
          classes={headerClasses}
          hero={data.hero}
          customHero={customHero}
          getStartedNowUrl={data.settings ? data.settings.getStartedNowUrl : ''}
          contacts={data.contacts}
          heroBodyStyle={heroBodyStyle}
          heroBodyClasses={heroBodyClasses}
          heroContainerId={heroContainerId}
        />
      )}
      <main style={{ paddingTop: topAdBannerOffset }}>{children}</main>
      {!footerDisable && data.settings && data.settings.footer && <Footer footer={data.settings.footer} />}
      <Modals />
      {data.settings?.welcomePopup?.enable && <WelcomeModal data={data.settings.welcomePopup} />}      
    </ExperimentProvider>
  )
}

export default Layout
